import classNames from 'classnames'

import { MissionReviewCompleteIcon } from '@local/assets/icons'

import Image from '@web/components/Image'

import styles from '../../MissionCard/Content/ProgressStamp/ProgressStamp.module.scss'
import { MissionCardProps } from '../../MissionCard/MissionCard'
import CheckAnimationStamp from '../../MissionStamp/CheckAnimationStamp'

interface Props {
  missionCard: MissionCardProps
  withAnimation?: boolean
  animationOrder?: number
  hideImage?: boolean
  isSummary?: boolean
}

const PhotoReviewMissionCardContent = ({
  missionCard,
  withAnimation = false,
  animationOrder,
  hideImage = false,
  isSummary,
}: Props) => {
  const displayTotalCount = missionCard.stampCountToComplete
  const stamps = missionCard.stampGroups.map(stamp => ({
    image: stamp.image,
  }))

  return (
    <ul
      className={classNames(styles.stamp_list, styles.type_single, styles.type_reviewer_of_month, {
        [styles.type_modal]: isSummary,
      })}
    >
      {Array(displayTotalCount)
        .fill(null)
        .map((_, index) => {
          const stampCount = stamps.length
          const isLastStamp = index === stampCount - 1
          const shouldDisplayStamped = index < stampCount

          if (isLastStamp && withAnimation)
            return (
              <CheckAnimationStamp key={index} order={animationOrder}>
                <div className={classNames(styles.number)}>{index + 1}</div>
              </CheckAnimationStamp>
            )

          const image = stamps[index]?.image

          return (
            <li className={classNames(styles.list_item, { [styles.type_complete]: shouldDisplayStamped })} key={index}>
              <div className={styles.list_item_inner}>
                <div className={styles.circle_area}>
                  <div className={classNames(styles.number, { place_blind: shouldDisplayStamped })}>{index + 1}</div>
                  {shouldDisplayStamped && (
                    <>
                      {!hideImage && image ? (
                        <>
                          <div className={styles.icon_area}>
                            <Image className={styles.img} src={image} width="100%" height="100%" alt="리뷰" />
                          </div>
                          <i className={styles.icon_complete_without_check} />
                        </>
                      ) : (
                        <MissionReviewCompleteIcon className={styles.icon} aria-hidden="true" />
                      )}
                      <span className="place_blind">완료</span>
                    </>
                  )}
                </div>
              </div>
            </li>
          )
        })}
    </ul>
  )
}

export default PhotoReviewMissionCardContent
